// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashed-card[data-v-02784b00]{height:100%;min-height:106px;border:2px dashed #bdbdbd!important;background-color:#fafafa;-webkit-transition:all .3s ease;transition:all .3s ease}.dashed-card[data-v-02784b00]:hover{background-color:#f0f0f0;border-color:#9e9e9e!important}", ""]);
// Exports
module.exports = exports;
